import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {DeliousApiClient} from "@/_global/api_clients/DeliousApiClient";

@Module({
    name: "PluClassesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class PluClassesStore extends VuexModule {
    // state
    private _response_l: Delious.PluClassListResponse = {} as any;
    private _response_m: Delious.PluClassListResponse = {} as any;
    private _response_s: Delious.PluClassListResponse = {} as any;

    // getter
    get all_l(): Delious.PluClassListResponse {
        return this._response_l.list ? this._response_l : {list: []};
    }
    get all_m(): Delious.PluClassListResponse {
        return this._response_m.list ? this._response_m : {list: []};
    }
    get all_s(): Delious.PluClassListResponse {
        return this._response_s.list ? this._response_s : {list: []};
    }

    @Action
    public async init(param: { storeId: number }) {
        const response_l: Delious.PluClassListResponse = await DeliousApiClient.getPluClassList(param.storeId, "l_class");
        response_l.list = response_l.list.filter(v => v.level == "l_class");
        this.setResponseL(response_l);
        const response_m: Delious.PluClassListResponse = await DeliousApiClient.getPluClassList(param.storeId, "m_class");
        response_m.list = response_m.list.filter(v => v.level == "m_class");
        this.setResponseM(response_m);
        const response_s: Delious.PluClassListResponse = await DeliousApiClient.getPluClassList(param.storeId, "s_class");
        response_s.list = response_s.list.filter(v => v.level == "s_class");
        this.setResponseS(response_s);
    }

    @Mutation
    private setResponseL(response: Delious.PluClassListResponse) {
        this._response_l = response;
    }
    @Mutation
    private setResponseM(response: Delious.PluClassListResponse) {
        this._response_m = response;
    }
    @Mutation
    private setResponseS(response: Delious.PluClassListResponse) {
        this._response_s = response;
    }

}

export default getModule(PluClassesStore);
